import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';

import { MenuService } from './menu.service';
import { MenuItem } from './menu.model';

@Component({
  selector: 'app-menu',
  standalone: true,
  templateUrl: './menu.component.html',
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class MenuComponent {

  // ✅ THIS IS WHAT WAS MISSING
  menu$: Observable<MenuItem[]>;

  private menuService = inject(MenuService);

  constructor() {
    this.menu$ = this.menuService.menu$;
  }
}
